import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

interface JSONStringProps {
  // children: React.ReactNode;
  data: any;
  keyToUrl?: { [key: string]: (value: string) => string };
  keyToDangerouslySetInnerHtml?: { [key: string]: boolean };
  topLevelFontSize?: number;
  nestedFontSize?: number;
}

const JSONString: React.FC<JSONStringProps> = ({
  data,
  keyToUrl,
  keyToDangerouslySetInnerHtml,
  topLevelFontSize,
  nestedFontSize,
}: JSONStringProps): JSX.Element => {
  keyToUrl = {
    // defaults
    job_id: (id) => `/jobs/${id}`,
    job_ids: (id) => `/jobs/${id}`,
    parent_job_id: (id) => `/jobs/${id}`,
    gpt_request_id: (id) => `/request/${id}`,
    request_ids: (id) => `/www/admin/request/${id}`,
    gpt_refine_ids: (id) => `/request/${id}`,
    dependencies: (id) => `/jobs/${id}`,
    doc_id: (id) => `/doc/${id}`,
    source_insight_ids: (id) => `/insights/${id}`,
    ...keyToUrl,
  };

  keyToDangerouslySetInnerHtml = {
    content: true,
    stdout: true,
    stderr: true,
    // prompt: true,
    // answer: true,
    ...keyToDangerouslySetInnerHtml,
  };

  const renderValue = (key: string, value: any) => {
    if (keyToUrl && keyToUrl[key]) {
      if (Array.isArray(value)) {
        return (
          <span>
            [
            {value.map((item, index) => {
              // @ts-ignore
              const url = keyToUrl[key](item);
              return (
                <span key={index}>
                  <Link href={url} rel="noopener noreferrer">
                    {JSON.stringify(item)}
                  </Link>
                  {index < value.length - 1 ? ", " : ""}
                </span>
              );
            })}
            ]
          </span>
        );
      }
      const url = keyToUrl[key](value);
      return (
        <Link href={url} rel="noopener noreferrer">
          {JSON.stringify(value)}
        </Link>
      );
    }
    if (keyToDangerouslySetInnerHtml && keyToDangerouslySetInnerHtml[key]) {
      return (
        // eslint-disable-next-line react/no-danger
        <div
          dangerouslySetInnerHTML={{ __html: value }}
          style={{ fontSize: nestedFontSize || 10 }}
        />
      );
    }

    let jsonString: any = JSON.stringify(value, null, " ");
    if (typeof value === "string" || value instanceof String) {
      jsonString = value;
    }

    // make big json content smaller
    if (jsonString.length > 300) {
      return (
        <span
          style={{ whiteSpace: "pre-wrap", fontSize: nestedFontSize || 10 }}
        >
          {jsonString}
        </span>
      );
      // eslint-disable-next-line react/no-danger
      // return (
      //   <div
      //     // dangerouslySetInnerHTML={{ __html: jsonString }}
      //     style={{ fontSize: nestedFontSize || 10 }}
      //   >
      //     {value}
      //   </div>
      // );
    }
    return (
      <span style={{ whiteSpace: "pre-wrap", fontSize: "0.7rem" }}>
        {jsonString}
      </span>
    );
    // return value;
    // return jsonString;
  };

  const renderJSON = (obj: any) => {
    if (typeof obj !== "object" || obj === null) {
      return obj;
    }

    return (
      <Box component="span">
        {"{"}
        {Object.keys(obj).map((key, index, array) => (
          <Box component="div" key={key}>
            <Typography
              component="span"
              sx={{
                fontFamily: "monospace",
                fontSize: topLevelFontSize || "0.7rem",
              }}
            >
              <b>{`  ${JSON.stringify(key)}: `}</b>
              {renderValue(key, obj[key])}
            </Typography>
            {index < array.length - 1 ? "," : ""}
          </Box>
        ))}
        {"}"}
      </Box>
    );
  };

  return (
    <Box sx={{ overflowX: "auto" }}>
      <Typography
        component="pre"
        sx={{
          fontFamily: "monospace",
          fontSize: "0.75rem", // Tiny text
          whiteSpace: "pre-wrap", // Keeps the formatting
          wordBreak: "break-all",
          backgroundColor: "#f5f5f5", // Light grey background
          padding: "8px",
          borderRadius: "4px",
          border: "1px solid #ddd", // Light border for emphasis
        }}
      >
        {renderJSON(data)}
      </Typography>
    </Box>
  );
};

export default JSONString;
